<template>
	<div class="movable-view" @mousedown.stop="moveStart" :style="{cursor: _cursor, left: value.left + '%', top: value.top + '%'}">
		<slot />
	</div>
</template>

<script>
	const bounds = {
		left: null,
		top: null,
		width: null,
		height: null,
		type: '%'
	};

	const snap = {
		horizontal: null,
		vertical: null
	};

	export default {
		name: 'movable-view',
		props: {
			value: {
				type: Object,
				default() {
					return {
						left: 0,
						top: 0
					};
				}
			},
			bounds: {
				type: Object,
				default() {
					return bounds;
				},
				validator(val) {
					return true;
				}
			},
			snap: {
				type: Object,
				default() {
					return snap;
				}
			}
		},
		data() {
			return {
				moving: false,
				view: {
					origin: {
						left: 0,
						top: 0
					}
				},
				origin: {
					left: 0,
					top: 0
				},
				absolute: {
					left: 0,
					top: 0
				}
			};
		},
		computed: {
			_cursor() {
				return this.moving ? 'grabbing' : 'grab';
			},
			_bounds() {
				return {...bounds, ...this.bounds};
			},
			_snap() {
				return {...snap, ...this.snap};
			},
			_relative() {
				return {
					left: this.absolute.left - this.origin.left, 
					top: this.absolute.top - this.origin.top 
				};
			}
		},
		methods: {
			moveStart(event) {
				this.moving = true;

				this.origin = {
					left: event.clientX,
					top: event.clientY
				};

				this.view.origin = this.value;

				window.addEventListener('mouseup', this.moveEnd);
				window.addEventListener('dragend', this.dragEnd);
				window.addEventListener('mousemove', this.mouseMove);
			},
			moveEnd(event) {
				this.moving = false;

				window.removeEventListener('mouseup', this.moveEnd);
				window.removeEventListener('dragend', this.dragEnd);
				window.removeEventListener('mousemove', this.mouseMove);
			},
			dragEnd(event) {
				this.moveEnd(event);
			},
			mouseMove(event) {
				this.absolute = {
					left: event.clientX,
					top: event.clientY
				};

				// Recalculate position
				var coeffLeft 	= this._relative.left / this.$el.parentElement.clientWidth;
				var coeffTop 	= this._relative.top / this.$el.parentElement.clientHeight;

				var newLeft 	= this.view.origin.left + (coeffLeft * 100);
				var newTop 		= this.view.origin.top + (coeffTop * 100);

				var pos = {
					left: this.normalizeLeft(newLeft),
					top: this.normalizeTop(newTop)
				};

				this.$emit('input', pos, event);
			},
			normalizeLeft(left) {
				var r = left;

				// Snap
				if (this._snap.horizontal !== null) r = Math.round(r / this._snap.horizontal) * this._snap.horizontal;

				// Clamp
				if (this.bounds.left !== null)		r = Math.max(this.bounds.left, r);
				if (this.bounds.width !== null) 	r = Math.min(this.bounds.left + this.bounds.width, r);

				return r;
			},
			normalizeTop(top) {
				var r = top;

				// Snap
				if (this._snap.vertical !== null) 	r = Math.round(r / this._snap.vertical) * this._snap.vertical;

				// Clamp
				if (this.bounds.top !== null) 		r 	= Math.max(this.bounds.top, r);
				if (this.bounds.height !== null)	r 	= Math.min(this.bounds.top + this.bounds.height, r);

				return r;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.movable-view {
		position: absolute;
	}
</style>